<!-- 首页-合作伙伴模块 -->
<template>
  <div class="partners-content">
    <div class="home-center">
      <div class="partners-section">
        <div class="title-wrap">
          <el-divider></el-divider>
          <span class="title">合作伙伴</span>
          <el-divider></el-divider>
        </div>
        <div class="partners-list">
          <div class="item" v-for="item of partners" :Key="item.id">
            <div class="logo-wrap">
              <img :src="item.logo" class="logo" alt="">
              <span class="name">{{ item.logoName }}</span>
            </div>
            <p class="para">{{ item.text }}</p>
          </div>
          <div class="wrap-item"></div>
        </div>
      </div>
      <section class="professors-section">
        <div class="title-wrap">
          <el-divider></el-divider>
          <span class="title">知名专家</span>
          <el-divider></el-divider>
        </div>
        <!-- <el-divider direction="vertical"></el-divider> -->
        <ul class="professors-list">
          <div class="item" v-for="item of professors" :Key="item.id">
            <div class="logo-wrap">
              <img :src="item.pic" class="logo" alt="">
            </div>
            <div class="para">
              <div class="name">{{ item.name }}</div>
            <p>{{ item.text }}</p>
            </div>
          </div>
          <div class="wrap-item"></div>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import { hikLogo, jdLogo, profName1, profName2, profName3, profName4 } from "@/utils/images.js";

export default {
  name: "partners",
  components: {},
  props: {},

  data() {
    return {
      partners: [
        {
          id: 1,
          logo: jdLogo,
          logoName: "京东",
          text: "京东集团定位于“以供应链为基础的技术与服务企业”，目前业务已涉及零售、数字科技、物流、技术服务、健康、保险、产发、智联云和海外等领域，" +
              "其中核心业务为零售、数字科技、物流、技术服务四大板块。2019年全年，京东集团研发投入达179亿元，跃升为中国企业中对技术投入最多的公司之一。"
        }, {
          id: 2,
          logo: hikLogo,
          logoName: "海康威视",
          text: "海康威视是全球领先的以视频为核心的物联网解决方案提供商，致力于不断提升视频处理技术和视频分析技术，面向全球提供领先的监控产品和技术解决方案。" +
              "2020年8月25日，在第六届中国职业教育合作峰会开幕式上，国匠云分别与海康威视签署了战略合作协议，双方将基于在各自领域的优势，深入开展职业教育方面的合作。"
        }
      ],
      professors: [
        {
          id: 1,
          name: "浦世亮   法国国家科学研究院(CNRS)博士",
          pic: profName1,
          text: "浙江大学理学博士，现任海康威视首席专家、研究院院长，负责公司在人工智能及大数据领域的技术研究。浦世亮带领研究院研发的Smart 265编码技术、" +
              "目标结构化算法、车牌识别算法、人脸识别算法、视频检索引擎、多传感器融合等技术，被广泛应用于公共安全、金融、交通、司法、零售、智慧城市等多个领域。"
        }, {
          id: 2,
          name: "王健宗 美国佛罗里达大学博士后",
          pic: profName2,
          text: "目前任职于平安科技（深圳）有限公司，工作岗位为副总工程师。先后发表论文三十余篇，申请专利百余项；获得国家级奖项“中国专利优秀奖”；参与《面向图计算的通用计算机技术与系统》" +
              "等两项国家重大专项项目；当选深圳市福田区人大代表、深圳市地方级领军人才；目前担任中国科技大学和中国地质大学兼职硕士生导师。是中国首位采用英伟达RAPIDS开源GPU数据加速平台的总工程师。"
        }, {
          id: 3,
          name: "张宗尧 理工学院电机与计算机科学博士",
          pic: profName3,
          text: "Synergies Intellige nt Systems,Inc. （简称“Synergies”或者“讯能集思”）创始人及CEO。2012年获得麻省理工学院(MIT)电机与计算机科学博士学位，研究内容涵盖机器学习、机器视觉与大数据平台建立。" +
              " 2016年，张宗尧在波士顿创办了Synergies讯能集思，致力于打造一栈式AI系统解决方案和开发人工智能决策自动化相关技术。"
        }, {
          id: 4,
          name: "徐习明 历任IBM中国有限公司工程师",
          pic: profName4,
          text: "部门经理、总监、咨询服务合伙人、咨询服务高级合伙人、副总裁，现任海康威视高级副总经理。"
        }
      ]
    };

  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() {

  },
  methods: {
    goToExperienceAi() {
    }
  },
  updated() {
  },
  destroyed() {
  },
  activated() {
  }
};
</script>
<style lang="scss" scoped>
%flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

%flex-start {
  display: flex;
  justify-content: start;
  align-items: center;
}

%flex-bewteen {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.partners-content {
  background: rgba(39,33,96,0.86);
  //padding-bottom: 130px;
  height:calc(100% - 70px);
  min-height: 1000px;
  overflow:hidden;
  ::v-deep .el-divider--horizontal {
    width: 45px;
    background: #C7CED5;
    opacity: 0.6;
  }

  .home-center {
    position: relative;
    width: 1200px;
    padding-bottom: 50px;
    padding-top: 76px;
    margin: 0 auto;
    height: 100%;
    color: #fff;

    .title-wrap {
      @extend %flex-center;
      .title {
        display: block;
        min-width: 120px;
        font-size: 30px;
        font-family: Microsoft YaHei;
        line-height: 36px;
        margin: 0 30px;
      }
    }

    .partners-section {
      .partners-list {
        // @extend %flex-start;
        width: 100%;
        height: 100%;
        margin: 50px 0 0 0;
        overflow: hidden;
        .item {
          // width: 600px;
          box-sizing: border-box;
          @extend %flex-start;

          .logo-wrap {
            width: 122px;
            height:122px;
            text-align: center;

            .logo {
              width: 89px;
              height: 89px;
              margin-top: 7px;
            }
            .name {
              display: block;
            }
          }

          .para {
            width: 408px;
            display: inline-block;
            text-align: justify;
            // width: calc(100% - 150px);
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #D2CBCB;
            line-height: 24px;
            margin-left: 20px;
          }
          &:nth-child(odd) {
          //  padding-right: 16px;
          //  border-right: 3px solid rgba(162, 162, 162, 0.1);
          //  height: 109px;
            float: left;
          }

          &:nth-child(even) {
            float: right;
            // padding-left: 16px;

            .logo {
              width: 116px;
              height: 63px;
            }
          }

        }
      }
    }

    .professors-section {
      margin: 60px 0 0 0;
      .el-divider--vertical{
        position: absolute;
        margin:65px auto 0 auto;
        background:rgba(162, 162, 162, 0.1);
        width: 3px;
        height:350px;
      }
      .professors-list {
        // @extend %flex-start;
        // flex-wrap: wrap;
        width: 100%;
        height: 100%;
        margin: 30px 0 0 0;
        .item {
          // max-width: 46%;
          box-sizing: border-box;
          margin:30px 0 0px 0;
          // height: 200px;
          @extend %flex-start;
          .logo-wrap {
            width: 122px;
            height: 122px;
            text-align: center;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .para{
           //  width:calc(100% - 120px);
            width: 408px;
            height: 116px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #D2CBCB;
            line-height: 24px;
            text-align: justify;
            padding: 0 0 0 20px;
            .name{
              color:#fff;
              font-size: 18px;
              font-family: Source Han Sans CN;
              margin-bottom: 14px;
            }
            p{ width:400px; }
          }
          &:nth-child(odd) {
            float: left;
          }

          &:nth-child(even) {
            float: right;
          }
          &:nth-child(1),
          &:nth-child(2) {
            margin-bottom: 80px;
          }
          // &:nth-child(2n-1) {
          //   padding-right: 16px;
          //   margin-right:60px;
          // }
          // &:nth-child(2n) {
          //   padding-left: 16px;
          // }
          //&:last-child{
          //  background: red;
          //  .para {
          //    height:auto ;
          //    color: red;
          //  //}
          //  }
          //}
        }

      }
    }



  }
}
</style>
